<template>
  <div>
    <h6>Data table</h6>
      <!-- @actionComplete="resizeStoped" -->
    <ejs-grid
      ref='grid'
      :dataSource="localData"
      :allowPaging="true"
      :pageSettings="pageSettings"
      :allowSorting="true"
      :allowFiltering="true"
      :allowResizing="true"
      @resizeStop="resizeStoped"
      :allowReordering="true"
      @columnDrag="beingDragged"
      @columnDrop="getColumns"
    >
      <e-columns>
        <e-column field="OrderID" headerText="Order Id"></e-column>
        <e-column field="CustomerID" headerText="Customer"></e-column>
        <e-column field="Freight" headerText="Freight"></e-column>
        <e-column field="col1" headerText="col1"></e-column>
        <e-column field="col2" headerText="col2"></e-column>
        <e-column field="col3" headerText="col3"></e-column>
        <e-column field="col4" headerText="col4"></e-column>
      </e-columns>
    </ejs-grid>
    <button @click="test">
      Test
    </button>
  </div>
</template>

<script>
import { Page, Sort, Filter, Resize, Reorder } from '@syncfusion/ej2-vue-grids'

export default {
  data: () => ({
    localData: [
      { OrderID: 10248, CustomerID: 'VINET', Freight: 32.38, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10249, CustomerID: 'TOMSP', Freight: 11.61, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10250, CustomerID: 'HANAR', Freight: 65.83, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10251, CustomerID: 'VICTE', Freight: 41.34, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10252, CustomerID: 'SUPRD', Freight: 51.31, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10253, CustomerID: 'HANAR', Freight: 58.17, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10254, CustomerID: 'CHOPS', Freight: 22.98, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10255, CustomerID: 'RICSU', Freight: 14.33, col1: 1, col2: 2, col3: 3, col4: 4 },
      { OrderID: 10256, CustomerID: 'WELLI', Freight: 13.97, col1: 1, col2: 2, col3: 3, col4: 4 }
    ],
    pageSettings: { pageSize: 5 },
    columns: [],
    colBeingDragged: '',
    colDraggedToIndex: null
  }),
  provide: {
    grid: [ Page, Sort, Filter, Resize, Reorder ]
  },
  mounted() {
    this.columns = this.$refs.grid.getColumns()
  },
  methods: {
    test() {
      
    },
    resizeStoped(event) {
      
    },
    beingDragged(event) {
      // 
      this.colBeingDragged = event.column.headerText
      this.colDraggedToIndex = event.target.cellIndex
    },
    getColumns() {
      let beingDragged = this.columns.findIndex(a => a.headerText === this.colBeingDragged)

      // this.columns.forEach(b => 
      // 

      let newSequence = []
      let diff = null
      this.columns.forEach((col, index) => {
        if (index === this.colDraggedToIndex) {
          newSequence.push(this.columns[beingDragged])

          if (diff === null) {
            diff = '-'
          } else {
            diff = null
          }
        } else if (index === beingDragged) {
          if (diff === '-') {
            newSequence.push(this.columns[index-1])
          } else {
            newSequence.push(this.columns[index+1])
          }

          if (diff === null) {
            diff = '+'
          } else {
            diff = null
          }
        } else {
          if (diff === '-') {
            newSequence.push(this.columns[index-1])
          } else if (diff === '+') {
            newSequence.push(this.columns[index+1])
          } else {
            newSequence.push(col)
          }
        }
      })
      
      newSequence.forEach(b => {
        
      })
      this.columns = newSequence
      this.colBeingDragged = null
      this.colDraggedToIndex = null

    }
  }
}
</script>

<style>

</style>